export default "./images/survio-2m9P1-assets-integrations-24.svg";